import { AuthGuard, GuestGuard, WorkspaceGuard } from '@/features/session';

// The router (app/) composes pages only; these wrap the session guards as route components.
export function GuestRoute() {
  return <GuestGuard />;
}

export function SignedInRoute() {
  return <AuthGuard />;
}

export function WorkspaceRoute() {
  return <WorkspaceGuard expects="workspace" />;
}

export function NewAccountRoute() {
  return <WorkspaceGuard expects="no-workspace" />;
}
